import type { NextPage } from "next";
import type { SVGProps } from "react";

interface Props extends SVGProps<SVGSVGElement> {
  isGradient?: boolean;
  gradientId?: string;
  from?: string;
  to?: string;
}

const BalconyIcon: NextPage<Props> = ({
  fill = "currentColor",
  from,
  to,
  gradientId = "BalconyIconGradient",
  isGradient = false,
  ...props
}) => {
  return (
    <svg
      width="24"
      height="25"
      viewBox="0 0 24 25"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      {isGradient && (
        <defs>
          <linearGradient id={gradientId}>
            <stop offset="0%" stopColor={from} />
            <stop offset="100%" stopColor={to} />
          </linearGradient>
        </defs>
      )}
      <path
        d="M20.7351 14.247H17.8234V8.38482C17.8234 5.17378 15.2111 2.56145 12 2.56145C8.78898 2.56145 6.17665 5.17378 6.17665 8.38482V14.247H3.26496C2.94331 14.247 2.68262 14.5077 2.68262 14.8293V21.8562C2.68262 22.1779 2.94331 22.4386 3.26496 22.4386H20.7351C21.0567 22.4386 21.3174 22.1779 21.3174 21.8562V14.8293C21.3174 14.5077 21.0567 14.247 20.7351 14.247ZM20.1527 18.9445H17.8234V15.4117H20.1527V18.9445ZM14.3294 18.9445V15.4117H16.6587V18.9445H14.3294ZM10.8353 18.9445V15.4117H13.1647V18.9445H10.8353ZM7.34133 18.9445V15.4117H9.67068V18.9445H7.34133ZM7.34133 9.54949H8.506V14.247H7.34133V9.54949ZM15.494 14.247V9.54949H16.6587V14.247H15.494ZM12.5824 6.12917C13.5858 6.38834 14.3294 7.30143 14.3294 8.38482H12.5824V6.12917ZM11.4177 8.38482H9.67068C9.67068 7.30143 10.4142 6.38834 11.4177 6.12917V8.38482ZM14.3294 9.54949V14.247H9.67068V9.54949H14.3294ZM16.6587 8.38482H15.4941C15.4941 6.65661 14.2328 5.2176 12.5824 4.93963V3.76252C14.8773 4.0499 16.6587 6.01316 16.6587 8.38482ZM11.4177 3.76252V4.93963C9.76729 5.21776 8.50601 6.65661 8.50601 8.38482H7.34134C7.34134 6.01316 9.12278 4.0499 11.4177 3.76252ZM6.17667 15.4117V18.9445H3.84732V15.4117H6.17667ZM20.1528 21.2739H3.8473V20.1092H20.1527L20.1528 21.2739Z"
        fill={isGradient ? `url(#${gradientId})` : fill}
      />
    </svg>
  );
};

export default BalconyIcon;
